import { IconSvg, IconSvgProps } from "./icon"

export default function SkipBackward(props: IconSvgProps) {
  return (
    <IconSvg {...props} fill="currentColor">
      <path
        d="M17.971 4.28502C18.2744 4.10292 18.6208 4.00462 18.9747 4.00016C19.3286 3.99569 19.6774 4.08522 19.9854 4.2596C20.2933 4.43398 20.5495 4.68697 20.7278 4.99274C20.906 5.2985 21 5.64609 21 6.00002V18C21 18.3539 20.906 18.7015 20.7278 19.0073C20.5495 19.3131 20.2933 19.5661 19.9854 19.7404C19.6774 19.9148 19.3286 20.0043 18.9747 19.9999C18.6208 19.9954 18.2744 19.8971 17.971 19.715L7.97396 13.717C7.67719 13.5397 7.43145 13.2885 7.26071 12.9879C7.08997 12.6873 7.00006 12.3476 6.99976 12.0019C6.99945 11.6562 7.08877 11.3163 7.25898 11.0154C7.4292 10.7145 7.6745 10.4628 7.97096 10.285L17.971 4.28502Z"
        strokeWidth={0}
      />
      <path d="M3 20V4" />
    </IconSvg>
  )
}
